import React from 'react';
import './site.css'; 
import map from '../images/juja.png'

const FullWidthImage = () => {
    return (
        <div>
        <h1>Site Map</h1>
        <div className="full-width-image-container">
            
            <img
                className="full-width-image"
                src={map} 
                alt="FullWidthImage"
            />
        </div>
        </div>
    );
};

export default FullWidthImage;
